import '../../assets/index.less'

const AgreementUserExperience = () => {
  document.title = '用户体验改善计划'
  return (
    <div className="page agreement">
      <div className="main">
        <img className="logo" src={require('../../assets/logo.png')} alt="" />
        <div className="h1">用户体验改善计划</div>
        <div className="p">
          欢迎您加入“用户体验改进计划”，为了改善产品的用户体验，元萝卜AI下棋机器人会根据需要对产品的各项功能使用情况进行统计，我们可以通过分析统计数据持续不断地提升产品操作体验、运行性能，改善功能设计，提供更优质的服务。在统计时，我们只对产品自身的内容进行统计，绝不涉及用户的个人隐私数据。
        </div>
        <div className="p">
          我们将根据棋局数据统计，以统计用户棋力水平，扩大AI等级范围，适应更多用户的棋力水平。能够在您的设备遇到问题时，远程为您的设备完成修复或升级任务。
        </div>
        <div className="section">
          <div className="h3">隐私安全</div>
          <div className="p">
            我们将严格遵守遵照国家有关的法律法规，本计划对相关数据信息的收集是完全匿名的，同时我们不会将收集的信息与其他任何个人信息进行匹配存储。我们仅为了提高产品对用户的服务质量和效率而收集相关信息，并将这些信息用于努力改善产品体验。
          </div>
        </div>
        <div className="section">
          <div className="h3">确认加入“用户体验改进计划”</div>
          <div className="p">
            可以通过打开设备管理-设备详情-加入“用户体验改善计划”中的开关，表示您加入了用户体验改进计划。
          </div>
        </div>
        <div className="section">
          <div className="h3">退出计划</div>
          <div className="p">
            根据您的意愿，自由设定是否加入“用户体验改进计划”，可以通过关闭开关退出计划。{' '}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgreementUserExperience
